/**
 * 우 패널 슬롯 (DESIGN §8.6.8).
 *
 * **전역이 아니다.** 지도·분석 두 페이지만 쓴다. 나머지 5개가 우 패널을 가지면
 * 중앙이 1440 − 272 − 300 − 여백 ≈ 788px 로 떨어져 `Section --split` 2열이
 * 죽는다 — 이 프로젝트의 명제가 "비교로 읽는 가동률"인데 비교의 물리적
 * 인접성을 잃는 것은 본말전도다.
 *
 * 두 페이지는 원래 각자 300px/320px 패널을 갖고 있었다. 셸 슬롯으로 승격해
 * 폭과 스타일을 하나로 만든다.
 */

import { useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

import { SideSlotCtx } from '@/lib/sideSlot'

export function SidePanel({ children }: { children: ReactNode }) {
  const el = useContext(SideSlotCtx)
  // 슬롯이 아직 마운트되지 않았거나 이 페이지에 슬롯이 없으면 아무것도 안 그린다
  if (el == null) return null
  return createPortal(children, el)
}
